import React, { useMemo } from 'react';
import ReactSpeedometer from 'react-d3-speedometer';

const Speedometer = ({ value, toPrint }) => {
  const colors = useMemo(
    () => (value ? ['#39C560', '#F8B239', '#E21B45'] : ['#828282', '#BDBDBD', '#E0E0E0']),
    [value]
  );

  const props = toPrint
    ? {
        width: 160,
        height: 80,
        ringWidth: 40,
      }
    : {
        width: 200,
        height: 100,
      };

  return (
    <div className="flex center risk-level-speedometer">
      <ReactSpeedometer
        segmentColors={colors}
        segments={3}
        maxSegmentLabels={0}
        needleHeightRatio={0.5}
        maxValue={3}
        minValue={1}
        value={value}
        forceRender
        needleTransitionDuration={0}
        needleColor="black"
        currentValueText=""
        {...props}
      />
    </div>
  );
};

export default Speedometer;
